import { render, staticRenderFns } from "./user-select-drawer.vue?vue&type=template&id=389f564c"
import script from "./user-select-drawer.vue?vue&type=script&lang=js"
export * from "./user-select-drawer.vue?vue&type=script&lang=js"
import style0 from "./user-select-drawer.vue?vue&type=style&index=0&id=389f564c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports